<div class="map-wrapper">
  <!-- {{ searchCriteria | json }} -->
  <div id="resizer"></div>
  <div id="map"></div>

  @if (!isMobile) {
    <div class="map-buttons">
      <!-- @if (boundCoordinates.SouthWest.Longitude !== 0) {
      <button id="reset-map" mat-flat-button (click)="resetMap()">
        Återstill kart
      </button>
    } -->
      <button
        id="toggle-map-size"
        mat-flat-button
        (click)="changeMapFullWidth()"
      >
        @if (mapFullWidth) {
          <span>Vis mindre kart</span>
        } @else {
          <span>Vis stor kart</span>
        }
      </button>
    </div>
  }
</div>

@if (selectedProperties && selectedProperties.length > 0) {
  <div id="info-window" #propertyComponent style="display: none">
    <app-property-list
      #propertyResults
      [properties]="selectedProperties"
      [fromMap]="true"
      [wider]="false"
      [settings]="settings"
    >
    </app-property-list>
  </div>
}
